<div class="modal-header blue">
  <h4 class="modal-title">Edit Group Case Number | {{ groupEnrollmentID }}</h4>
  <a href="javascript:void(0)" (click)="close()" class="modal-close-btn"></a>
</div>

<div class="modal-body" [formGroup]="caseNumberForm">
  <div class="input-label">Case Number</div>

  <div class="input-wrap w-100">
    <textarea
      placeholder="Enter Notes"
      formControlName="caseNumber"
      rows="5"
      [class.is-invalid]="
        caseNumberForm.get('caseNumber')?.invalid &&
        caseNumberForm.get('caseNumber')?.touched
      "
    ></textarea>
  </div>
  <div
    class="invalid-feedback text-left d-block"
    *ngIf="
      caseNumberForm.get('caseNumber')?.invalid &&
      caseNumberForm.get('caseNumber')?.touched
    "
  >
    <div *ngIf="caseNumberForm.get('caseNumber')?.errors?.required">
      This field is required
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="submit"
    (click)="save()"
    [disabled]="caseNumberForm.invalid || isLoading"
    class="button ml-auto w-100px"
  >
    Save
  </button>
</div>
